/*
 * Saves strings or objects as JSON strings in browser storage.
 */

import __ from './../utils/translation';

let host = window.location.host;
let parts = host.split(".");
let subdomain = "";

if (parts.length >= 3) {
  subdomain = parts[0];
}

var baseURLEditor = 'https://'+ subdomain +'.aibizbox.co/';
// check if localStorage is supported
let localStorageSupported;
try {
  localStorage.setItem('test', 'item');
  localStorage.removeItem('test');
  localStorageSupported = true;
} catch (e) {
  localStorageSupported = false;
}


// detect if string is a stringified JSON
const isJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}


// save
const save = (name, value) => {
  if (!localStorageSupported) {
    alert(__('Browser storage is not supported in this browser!'));
    return;
  }

  // if item is an object, stringify
  if (value instanceof Object) {
    value = JSON.stringify(value);
  }

  localStorage.setItem(name, value);
}

const saveServer = (name, value, data) => {
  const imageData = data.toString().replace(/^data:image\/(png|jpeg|jpg);base64,/, '');
  const byteCharacters = atob(imageData);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const file = new Blob([byteArray], { type: 'image/png' + ';base64' });
  // instead it is necessary to use msSaveOrOpenBlob

  if (value instanceof Object) {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);
    let token = params.get('token')
    let fileId = params.get('fileId')
    const formData = new FormData();
    formData.append('fileId', fileId);
    formData.append('file', JSON.stringify(value));
    formData.append('image', file, 'image.png');
    formData.append('editor_version', token);
    fetch(baseURLEditor+'image-editor/save-file', {
      mode: 'no-cors',
      method: 'POST',
      body: formData,
      credentials: "include"
    }).then(function (response) {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Network response was not ok.');
    }).then(function (res) {
      if (res.status) {
          //window.parent.location.href = baseURLEditor+'my-template';
      } else {
        alert('File Load Error')
      }
    });
  }
}


// load
const load = (name) => {
  let value = localStorage.getItem(name);

  // if item is JSON, unstringify
  if (isJsonString(value)) {
    value = JSON.parse(value);
  }

  return value;
}

const loadServer = () => {
  return new Promise(function (resolve, reject) {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);
    let fileId = params.get('fileId')
    let token = params.get('token')
    const formData = new FormData();
    formData.append('fileId', fileId);
    formData.append('editor_version', token);

    fetch(baseURLEditor+"image-editor/get-file",
      {
        method: "POST",
        credentials: "include",
        body: formData
      }).then(function (response) {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Network response was not ok.');
      }).then(function (res) {
        if (res.status) {
          if (isJsonString(res.data.content)) {
            let value = JSON.parse(res.data.content);
            resolve(value);
          } else {
            resolve('');
          }
        } else {
          alert('File Load Error')
        }
      });
  });
}
// remove
const remove = (name) => {
  localStorage.removeItem(name);
}


export default {
  save, load, remove, saveServer, loadServer
}
